module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-100.ab49e26e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-100.png
// module id = 3354
// module chunks = 11